export const Routes = {
  Home: { path: '/' },
  Login: {
    path: '/auth/:lang/login',
    withLanguage: (language) => `/auth/${language}/login`,
    withLanguageAndRedirect: (language, redirectPath) =>
      `/auth/${language}/login?redirectTo=${redirectPath}`,
  },
  Register: {
    path: '/auth/register',
    withLanguage: (language) => `/auth/register?language=${language}`,
  },
  AccountCreated: { path: '/auth/account-created' },
  ChangePassword: { path: '/auth/change-password' },
  ForgotPassword: { path: '/auth/forgot-password' },
  ForgotPasswordSet: {
    path: '/reset-password',
    withParams: (uid, token, language) =>
      `/reset-password?uid=${uid}&token=${token}&language=${language}`,
  },
  EmailVerification: { path: '/auth/email-verification/:token' },
  ResendEmailVerification: { path: '/auth/resend-email-verification' },
  ServerError: { path: '/server-error' },
  Profile: { path: '/profile' },
  ProfileEdit: { path: '/profile/edit' },
  Dashboard: {
    path: '/dashboard',
    withLanguage: (language) => `/dashboard?language=${language}`,
  },
  Account: { path: '/account' },
  Contact: { path: '/contact' },
  AccountSubscribe: {
    path: '/account/subscribe',
    withLanguage: (language) => `/account/subscribe?language=${language}`,
  },
  MedicalDocumentsList: { path: '/medical-documents' },
  MedicalDocumentCreate: { path: '/medical-documents/create' },
  MedicalDocument: { path: '/medical-documents/:id' },
  MedicalDocumentEdit: { path: '/medical-documents/:id/edit' },
  HealthReportsList: { path: '/health-reports' },
  HealthReportCreate: { path: '/health-reports/create' },
  HealthReport: { path: '/health-reports/:id' },
  // SummaryReportsList: { path: '/summary-reports' },
  // SummaryReportCreate: { path: '/summary-reports/create' },
  // SummaryReport: { path: '/summary-reports/:id' },
  HealthDataSurvey: { path: '/health-data-survey' },
  Calendar: { path: '/calendar' },
  Disclaimers: {
    path: '/Disclaimers',
    withLanguage: (language) => `/Disclaimers?language=${language}`,
  },
  Privacy: {
    path: '/Privacy',
    withLanguage: (language) => `/Privacy?language=${language}`,
  },
  Terms: {
    path: '/terms',
    withLanguage: (language) => `/terms?language=${language}`,
  },
  HowItWorks: {
    path: '/how-it-works',
    withLanguage: (language) => `/how-it-works?language=${language}`,
  },
  Presentation: { path: '/presentation' },
  LaboratoryTestsList: { path: '/laboratory-tests' },
  GeneticProfile: { path: '/genetic-profile' },
  SkinMoles: { path: '/skin-moles' },
  SharedAccessLinks: { path: '/shared-access-links' },
  PublicSharedAccess: {
    path: '/shared/:token',
    withToken: (token) => `/shared/${token}`,
  },
  PriceList: { path: '/price-list' },
  HealthCalculators: { path: '/health-calculators' },
  MedicalPersonaAi: { path: '/medical-persona-ai' },
  EmailPreferences: {
    path: '/account/email-preferences',
    withToken: (token, email) =>
      `/account/email-preferences?token=${token}&email=${encodeURIComponent(email)}`,
  },
};
